import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { changeFirstPassword } from "../../actions/auth";
import { TextField, InputAdornment, IconButton, CircularProgress } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import styles from "./FirstLoginChangePassword.module.css";
const LOGO_URL = process.env.PUBLIC_URL + "/logo.svg";
const FirstLoginChangePassword = () => {
  const {
    t,
    i18n
  } = useTranslation("admin");
  const dispatch = useDispatch();
  const history = useHistory();
  const isLoading = useSelector(state => state.auth.isLoading);
  const lang = i18n.resolvedLanguage;
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [error, setError] = useState("");
  const handleSubmit = e => {
    e.preventDefault();
    setError("");
    if (newPassword.length < 6) {
      setError(t("password_min_length") || "Password must be at least 6 characters");
      return;
    }
    if (newPassword !== confirmPassword) {
      setError(t("passwords_do_not_match") || "Passwords do not match");
      return;
    }
    dispatch(changeFirstPassword(newPassword, history, lang)).catch(msg => setError(msg || "Failed to change password"));
  };
  return <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.logoWrapper}>
          <img src={LOGO_URL} alt={t("Logo")} className={styles.logo} />
        </div>

        <h1 className={styles.title}>
          {t("change_your_password") || "Change Your Password"}
        </h1>
        <p className={styles.subtitle}>
          {t("first_login_password_prompt") || "For your security, please set a new password before continuing."}
        </p>

        {error && <div className={styles.errorBanner}>{error}</div>}

        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.fieldGroup}>
            <label className={styles.label}>
              {t("new_password") || "New Password"}
            </label>
            <TextField type={showNew ? "text" : "password"} placeholder="••••••••" value={newPassword} onChange={e => setNewPassword(e.target.value)} fullWidth size="small" required variant="outlined" InputProps={{
            endAdornment: <InputAdornment position="end">
                    <IconButton onClick={() => setShowNew(!showNew)} edge="end" size="small" tabIndex={-1}>
                      {showNew ? <VisibilityOffOutlinedIcon style={{
                  color: "#aaa",
                  fontSize: 20
                }} /> : <VisibilityOutlinedIcon style={{
                  color: "#aaa",
                  fontSize: 20
                }} />}
                    </IconButton>
                  </InputAdornment>
          }} sx={fieldSx} />
          </div>

          <div className={styles.fieldGroup}>
            <label className={styles.label}>
              {t("confirm_password") || "Confirm Password"}
            </label>
            <TextField type={showConfirm ? "text" : "password"} placeholder="••••••••" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} fullWidth size="small" required variant="outlined" InputProps={{
            startAdornment: <InputAdornment position="start">
                    <LockOutlinedIcon style={{
                color: "#aaa",
                fontSize: 20
              }} />
                  </InputAdornment>,
            endAdornment: <InputAdornment position="end">
                    <IconButton onClick={() => setShowConfirm(!showConfirm)} edge="end" size="small" tabIndex={-1}>
                      {showConfirm ? <VisibilityOffOutlinedIcon style={{
                  color: "#aaa",
                  fontSize: 20
                }} /> : <VisibilityOutlinedIcon style={{
                  color: "#aaa",
                  fontSize: 20
                }} />}
                    </IconButton>
                  </InputAdornment>
          }} sx={fieldSx} />
          </div>

          <button type="submit" className={styles.submitBtn} disabled={isLoading}>
            {isLoading ? <CircularProgress size={20} style={{
            color: "#fff"
          }} /> : t("save_new_password") || "Save New Password"}
          </button>
        </form>
      </div>
    </div>;
};
const fieldSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    backgroundColor: "#fff",
    fontSize: "0.9rem",
    "& fieldset": {
      borderColor: "#e0e0e0"
    },
    "&:hover fieldset": {
      borderColor: "#1c5e1c"
    },
    "&.Mui-focused fieldset": {
      borderColor: "#1c5e1c",
      borderWidth: 1.5
    }
  }
};
export default FirstLoginChangePassword;
